import { Invoice } from 'entities/Invoice/model/types';
import { useMemo } from 'react';
import { roundNumber } from 'shared/utils/helpers/roundNumber';

interface HookApi {
  isBalancePayAvaliable: boolean;
  amountToCharge: number;
}

export const useBalancePay = (invoice: Invoice): HookApi => {
  const { user } = invoice;

  const isBalancePayAvaliable = useMemo(() => {
    return user.balance > 0 && invoice.debt > 0;
  }, [invoice.debt, user.balance]);

  const amountToCharge = useMemo(() => {
    if (user.balance === 0 || !isBalancePayAvaliable) {
      return 0;
    }

    const fullDebt = roundNumber(invoice.debt);

    return fullDebt < user.balance ? fullDebt : user.balance;
  }, [invoice.debt, isBalancePayAvaliable, user.balance]);

  return { isBalancePayAvaliable, amountToCharge };
};
